export default function removeParamFromURL(
  path: string,
  param: string,
): string {
  const searchValue = new RegExp(`(${param}&)|(&${param})|(${param})`)

  const pathWithoutParam = path.replace(searchValue, '')

  const paramsLeft = pathWithoutParam.split('?')[1]

  return !paramsLeft ? pathWithoutParam.replace('?', '') : pathWithoutParam
}
